import Icons from "../svg/Icons.ts";
import * as amplify from "../util/amplify.ts";
import * as modal from "../util/modal.ts";
import * as Html from "../util/Html.ts";
import ApiServer from "../ApiServer.ts";

Html.registerWidget('specialdays/specialdays_details_widget',{initDom})

export function initDom(domNode: HTMLElement){
  const metaId = Html.getDomMetaId(domNode);

  domNode.querySelector<HTMLTextAreaElement>('textarea[name="description"]').addEventListener('change',function(){

    ApiServer.evtupdate("OnlyOne",{
      metaId:metaId,
      description:this.value
    },function(){
      modal.toast({svg:Icons.ic_done,text:"toasts.notesaved"})
    })
    amplify.publish('eventUpdated')
  });

  domNode.querySelector<HTMLInputElement>('*[name="where"]').addEventListener('change',function(){
    ApiServer.evtupdate("OnlyOne",{
      metaId:metaId,
      where:this.value,
      placeId:this.previousElementSibling.value||'$empty'
    },function(){
      modal.toast({svg:Icons.ic_done,text:"toasts.locationsaved"})
    })
    amplify.publish('eventUpdated')
  })

  domNode.querySelector<HTMLElement>('.addlocationopener')?.addEventListener('click',function(){
    this.style.display='none';
    this.previousElementSibling.style.display='flex'
  })
}